import Vue from 'vue'
import VueLodash from 'vue-lodash'
import { each, values, has, map, isEmpty, find, uniq } from 'lodash'

Vue.use(VueLodash, { lodash: { each, values, has, map, isEmpty, find, uniq } });